<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  import './assets/css/common.css'

  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    components: {},
  mounted() {
    window.onload = function () {
      // console.log(window.sessionStorage["token"]);
      if (!window.sessionStorage["token"]) {
        // 关闭浏览器
       localStorage.removeItem('token');
       location.reload() 
      } else {
        // 刷新
      }
    };
    window.onunload = function () {
      window.sessionStorage["token"] = true;
    };
    window.onbeforeunload = function () {
      window.sessionStorage["token"] = true;
    };
  },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue